import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import App from './App.vue'
import router from './router/router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueRouter from 'vue-router'
import VueMask from 'v-mask'

import VueMeta from 'vue-meta'
import {api} from "@/mixins/axios";

export const eventBus = new Vue();

Vue.config.errorHandler = function(err, vm, info) {
  const data = {
      err: err.message,
      info: info,
      location: window.location.href.split("#")[0]
  };

  console.log(data);

  api.put(`/feedback/log`, data)
}

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueMask)
Vue.use(VueMeta)

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
